import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export enum DuluxOus {
    "BlueStore" = "62c7a694-455d-4b82-a1ba-ec2e57f80727",
    "Country" = "e1f06452-a9af-465c-a01d-3c1f33b527c0",
    "Zone" = "480070d0-9fa3-4916-90d6-6855113e6071",
    "State" = "9064f5c4-ef69-4504-abd8-72d62f2096bf",
}

export const DULUX__OU__BLUE_STORE__NAME__COLUMN_ID = "df64dfbd-13f9-465f-9b5b-c3aa341da6ba" as Uuid;

export const DULUX__OU__COUNTRY__NAME__COLUMN_ID = "379ea6c7-c0b0-4cf4-ad21-0e5f02a16070" as Uuid;

export const DULUX__OU__ZONE__NAME__COLUMN_ID = "b360a1a5-6d13-4dd0-937f-7c8821d9d545" as Uuid;

export const DULUX__OU__STATE__NAME__COLUMN_ID = "b173ef53-9f7b-4f10-b171-bf3224402ca4" as Uuid;
